import SearchResults from 'scripts/defa/search-results/collection-search-results';

/**
 * defa.models.SearchResult
 * A SearchResult for a Technical Support user, could contain nested search results.
 * @version 1.2.0
 */
import Model         from 'scripts/poppet/model';

const SearchResult = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	defaults: {
		bid    : '',
		class  : '',
		title  : '',
		info   : [], // term/description pairs
		meta   : [], // key/value pairs
		related: [], // nested related SearchResults
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Create collections of related search results from the related objects.
	 * @void
	 */
	initialize: function ( options ) {
		if ( options.related ) {
			this.set( 'related', new SearchResults( options.related ) );
		}
		
		Model.prototype.initialize.call( this, options );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default SearchResult;